// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-wrapper {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 30px 20px;
    min-height: 80vh;
}

.dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    flex-wrap: wrap;
    gap: 16px;
}

.dashboard-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
}

.points-pill {
    background-color: #DCFCE7;
    color: #166534;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 0.85rem;
    font-weight: 700;
    border: 1px solid #BBF7D0;
    display: inline-block;
}

.dashboard-title h1 {
    font-size: 2rem;
    font-weight: 800;
    color: var(--brand-primary);
    margin: 0;
    letter-spacing: -0.5px;
}

.dashboard-title .subtitle {
    font-size: 0.95rem;
    color: var(--text-muted);
    margin-top: 4px;
    display: block;
}

.season-badge {
    background-color: transparent;
    border: 1px solid var(--brand-accent);
    color: var(--brand-primary);
    font-weight: 700;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
}

.dashboard-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
    gap: 24px;
    width: 100%;
    align-items: start;
}

@media (max-width: 900px) {
    .dashboard-grid {
        grid-template-columns: 1fr;
    }
}

.left-column, .right-column {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    min-width: 0;
}

.match-card {
    background: linear-gradient(135deg, var(--brand-primary) 0%, #1e293b 100%);
    color: white;
    border-radius: var(--radius-lg);
    padding: 24px;
    box-shadow: var(--shadow-card);
    position: relative;
    overflow: hidden;
}

.match-card::before {
    content: '';
    position: absolute;
    top: -50px;
    right: -50px;
    width: 150px;
    height: 150px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 50%;
    pointer-events: none;
}

.match-card, .upcoming-card, .stats-card {
    width: 100%;
    max-width: 100%;
}

.card-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
    z-index: 2;
}

.card-label {
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 1px;
    opacity: 0.8;
    font-weight: 600;
}

.icon-action {
    background: rgba(255,255,255,0.1);
    border: none;
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.icon-action:hover {
    background: rgba(255,255,255,0.2);
}

.match-info {
    text-align: center;
    margin-bottom: 24px;
}

.match-date-badge {
    display: inline-flex;
    flex-direction: column;
    background: rgba(255,255,255,0.1);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255,255,255,0.1);
    padding: 8px 16px;
    border-radius: 12px;
    margin-bottom: 16px;
}

.match-date-badge .day {
    font-size: 1.8rem;
    font-weight: 800;
    color: var(--brand-accent);
    line-height: 1;
}

.match-date-badge .month {
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    opacity: 0.9;
}

.opponent-title {
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0 0 16px 0;
}

.match-meta {
    display: flex;
    justify-content: center;
    gap: 20px;
    font-size: 0.9rem;
    opacity: 0.9;
}

.meta-item {
    display: flex;
    align-items: center;
    gap: 6px;
}

.btn-hero {
    width: 100%;
    background-color: var(--brand-accent);
    color: var(--brand-accent-fg);
    border: none;
    padding: 12px;
    border-radius: var(--radius-md);
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.2s;
}

.btn-hero:hover {
    transform: translateY(-2px);
    filter: brightness(1.05);
}

.btn-icon-row {
    background: transparent;
    border: none;
    color: #94a3b8;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    transition: all 0.2s;
    font-size: 0.9rem;
}

.btn-icon-row:hover {
    background-color: rgba(0,0,0,0.05);
    color: var(--brand-primary);
    transform: scale(1.1);
}

.upcoming-card {
    background: var(--bg-card);
    border-radius: var(--radius-lg);
    padding: 24px;
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--border-light);
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.section-header h3 {
    margin: 0;
    font-size: 1.1rem;
    color: var(--brand-primary);
}

.btn-text {
    background: none;
    border: none;
    color: var(--brand-primary);
    font-weight: 600;
    cursor: pointer;
    font-size: 0.85rem;
    padding: 4px 8px;
    border-radius: 4px;
}

.btn-text:hover {
    background: var(--bg-app);
}

.match-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.match-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;
}

.match-row:hover {
    background-color: var(--bg-app);
}

.date-box {
    background: var(--bg-app);
    color: var(--brand-primary);
    font-weight: 700;
    padding: 6px 10px;
    border-radius: 8px;
    font-size: 0.8rem;
    min-width: 50px;
    text-align: center;
}

.match-row-info {
    flex: 1;
}

.match-row-opponent {
    font-weight: 600;
    color: var(--text-main);
    display: block;
}

.match-row-time {
    font-size: 0.8rem;
    color: var(--text-muted);
}

.americanas-widget {
    border-left: 4px solid var(--brand-accent);
}

.americana-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px;
    border-radius: 8px;
    cursor: pointer;
    background-color: #fff;
    border: 1px solid var(--border-light);
    transition: all 0.2s;
    margin-bottom: 8px;
}

.americana-row:hover {
    background-color: var(--bg-app);
    border-color: var(--brand-accent);
    transform: translateX(2px);
}

.date-box.yellow {
    background-color: var(--brand-accent);
    color: var(--brand-primary);
    font-weight: 800;
}

.action-arrow {
    margin-left: auto;
    color: var(--brand-accent);
    font-size: 0.9rem;
}

.btn-dashed {
    width: 100%;
    background: transparent;
    border: 1px dashed var(--border-light);
    color: var(--text-muted);
    padding: 10px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    font-size: 0.85rem;
    margin-top: 10px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.btn-dashed:hover {
    border-color: var(--brand-primary);
    color: var(--brand-primary);
    background-color: #fff;
}

.stats-card {
    background: var(--bg-card);
    border-radius: var(--radius-lg);
    padding: 24px;
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--border-light);
    height: 100%;
}

.table-responsive {
    overflow-x: auto;
}

.custom-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 500px;
}

.custom-table th {
    text-align: left;
    padding: 12px;
    font-size: 0.75rem;
    text-transform: uppercase;
    color: var(--text-muted);
    border-bottom: 1px solid var(--border-light);
}

.custom-table td {
    padding: 12px;
    border-bottom: 1px solid var(--bg-app);
    color: var(--text-main);
    font-size: 0.95rem;
}

.custom-table tr:hover td {
    background-color: #F8FAFC;
}

.player-cell {
    display: flex;
    align-items: center;
    gap: 12px;
}

.avatar-circle {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: var(--brand-accent);
    color: var(--brand-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 0.8rem;
}

.points-badge {
    font-weight: 800;
    color: var(--brand-primary);
    background: rgba(15, 23, 42, 0.05);
    padding: 4px 8px;
    border-radius: 6px;
}

.empty-hero {
    text-align: center;
    padding: 40px 0;
    opacity: 0.7;
}

.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 100px 20px;
    color: var(--text-muted);
}

.spinner {
    width: 44px;
    height: 44px;
    border: 4px solid var(--border-light);
    border-top: 4px solid var(--brand-primary);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.info-banner-modern {
    background-color: #F0F9FF;
    border: 1px solid #BAE6FD;
    color: #0369A1;
    padding: 16px;
    border-radius: var(--radius-md);
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 0.95rem;
    animation: fadeIn 0.4s ease-out;
}

.info-banner-modern i {
    font-size: 1.2rem;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
}

.error-banner {
    background-color: #FEF2F2;
    border: 1px solid #FECACA;
    color: var(--error);
    padding: 12px;
    border-radius: var(--radius-md);
    margin-bottom: 20px;
    text-align: center;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.modal-content {
    background: white;
    padding: 24px;
    border-radius: var(--radius-lg);
    width: 90%;
    max-width: 450px;
    box-shadow: var(--shadow-card);
    position: relative;
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(-20px); }
    to { opacity: 1; transform: translateY(0); }
}

.modal-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 20px;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 24px;
}

.form-group label {
    display: block;
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--text-main);
    margin-bottom: 6px;
}

.form-control {
    width: 100%;
    height: 44px;
    padding: 0 12px;
    background-color: var(--bg-input);
    border: 1px solid var(--border-light);
    border-radius: var(--radius-input);
    font-size: 0.95rem;
    color: var(--text-main);
    box-sizing: border-box;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.btn-submit {
    background-color: var(--brand-primary);
    color: #fff;
    border: none;
    padding: 10px 20px;
    border-radius: var(--radius-input);
    font-weight: 700;
    cursor: pointer;
}

.btn-submit:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

@media (max-width: 1024px) {
    .dashboard-grid {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .dashboard-grid > div {
        width: 100%;
    }
}

@media (max-width: 600px) {
    .dashboard-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .dashboard-meta {
        align-items: flex-start;
        width: 100%;
        flex-direction: row;
        flex-wrap: wrap;
    }

    stats-card {
        padding: 15px 10px;
    }

    .custom-table {
        min-width: auto;
    }

    .custom-table th,
    .custom-table td {
        padding: 8px 4px;
        font-size: 0.8rem;
    }

    .custom-table td {
        padding: 10px 4px;
    }

    .avatar-circle.compact {
        width: 23px;
        height: 23px;
        min-width: 23px;
        font-size: 0.8rem;
    }

    .player-cell {
        gap: 8px;
    }

    .player-name-text {
        max-width: 100px;
        font-size: 0.875rem;
        font-weight: 500;
    }

    .points-badge {
        padding: 2px 4px;
        font-size: 0.75rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,qCAAqC;IACrC,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0EAA0E;IAC1E,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,iCAAiC;IACjC,0BAA0B;IAC1B,uCAAuC;IACvC,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,qCAAqC;IACrC,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,aAAa;IACb,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,qCAAqC;IACrC,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,sCAAsC;IACtC,wBAAwB;IACxB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,aAAa;IACb,4BAA4B;IAC5B,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;IACxB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,0CAA0C;IAC1C,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,OAAO,UAAU,EAAE,4BAA4B,EAAE;IACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,+BAA+B;IAC/B,UAAU;IACV,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,OAAO,UAAU,EAAE,4BAA4B,EAAE;IACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,kCAAkC;IAClC,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;QACvB,WAAW;QACX,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ","sourcesContent":[".dashboard-wrapper {\n    width: 100%;\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 30px 20px;\n    min-height: 80vh;\n}\n\n.dashboard-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 30px;\n    flex-wrap: wrap;\n    gap: 16px;\n}\n\n.dashboard-meta {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 8px;\n}\n\n.points-pill {\n    background-color: #DCFCE7;\n    color: #166534;\n    padding: 4px 12px;\n    border-radius: 12px;\n    font-size: 0.85rem;\n    font-weight: 700;\n    border: 1px solid #BBF7D0;\n    display: inline-block;\n}\n\n.dashboard-title h1 {\n    font-size: 2rem;\n    font-weight: 800;\n    color: var(--brand-primary);\n    margin: 0;\n    letter-spacing: -0.5px;\n}\n\n.dashboard-title .subtitle {\n    font-size: 0.95rem;\n    color: var(--text-muted);\n    margin-top: 4px;\n    display: block;\n}\n\n.season-badge {\n    background-color: transparent;\n    border: 1px solid var(--brand-accent);\n    color: var(--brand-primary);\n    font-weight: 700;\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 0.85rem;\n}\n\n.dashboard-grid {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);\n    gap: 24px;\n    width: 100%;\n    align-items: start;\n}\n\n@media (max-width: 900px) {\n    .dashboard-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.left-column, .right-column {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    width: 100%;\n    min-width: 0;\n}\n\n.match-card {\n    background: linear-gradient(135deg, var(--brand-primary) 0%, #1e293b 100%);\n    color: white;\n    border-radius: var(--radius-lg);\n    padding: 24px;\n    box-shadow: var(--shadow-card);\n    position: relative;\n    overflow: hidden;\n}\n\n.match-card::before {\n    content: '';\n    position: absolute;\n    top: -50px;\n    right: -50px;\n    width: 150px;\n    height: 150px;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 50%;\n    pointer-events: none;\n}\n\n.match-card, .upcoming-card, .stats-card {\n    width: 100%;\n    max-width: 100%;\n}\n\n.card-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    position: relative;\n    z-index: 2;\n}\n\n.card-label {\n    text-transform: uppercase;\n    font-size: 0.75rem;\n    letter-spacing: 1px;\n    opacity: 0.8;\n    font-weight: 600;\n}\n\n.icon-action {\n    background: rgba(255,255,255,0.1);\n    border: none;\n    color: white;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s;\n}\n\n.icon-action:hover {\n    background: rgba(255,255,255,0.2);\n}\n\n.match-info {\n    text-align: center;\n    margin-bottom: 24px;\n}\n\n.match-date-badge {\n    display: inline-flex;\n    flex-direction: column;\n    background: rgba(255,255,255,0.1);\n    backdrop-filter: blur(4px);\n    border: 1px solid rgba(255,255,255,0.1);\n    padding: 8px 16px;\n    border-radius: 12px;\n    margin-bottom: 16px;\n}\n\n.match-date-badge .day {\n    font-size: 1.8rem;\n    font-weight: 800;\n    color: var(--brand-accent);\n    line-height: 1;\n}\n\n.match-date-badge .month {\n    font-size: 0.8rem;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    opacity: 0.9;\n}\n\n.opponent-title {\n    font-size: 1.5rem;\n    font-weight: 700;\n    margin: 0 0 16px 0;\n}\n\n.match-meta {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    font-size: 0.9rem;\n    opacity: 0.9;\n}\n\n.meta-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.btn-hero {\n    width: 100%;\n    background-color: var(--brand-accent);\n    color: var(--brand-accent-fg);\n    border: none;\n    padding: 12px;\n    border-radius: var(--radius-md);\n    font-weight: 700;\n    cursor: pointer;\n    transition: transform 0.2s;\n}\n\n.btn-hero:hover {\n    transform: translateY(-2px);\n    filter: brightness(1.05);\n}\n\n.btn-icon-row {\n    background: transparent;\n    border: none;\n    color: #94a3b8;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 8px;\n    transition: all 0.2s;\n    font-size: 0.9rem;\n}\n\n.btn-icon-row:hover {\n    background-color: rgba(0,0,0,0.05);\n    color: var(--brand-primary);\n    transform: scale(1.1);\n}\n\n.upcoming-card {\n    background: var(--bg-card);\n    border-radius: var(--radius-lg);\n    padding: 24px;\n    box-shadow: var(--shadow-sm);\n    border: 1px solid var(--border-light);\n}\n\n.section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n}\n\n.section-header h3 {\n    margin: 0;\n    font-size: 1.1rem;\n    color: var(--brand-primary);\n}\n\n.btn-text {\n    background: none;\n    border: none;\n    color: var(--brand-primary);\n    font-weight: 600;\n    cursor: pointer;\n    font-size: 0.85rem;\n    padding: 4px 8px;\n    border-radius: 4px;\n}\n\n.btn-text:hover {\n    background: var(--bg-app);\n}\n\n.match-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.match-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.match-row:hover {\n    background-color: var(--bg-app);\n}\n\n.date-box {\n    background: var(--bg-app);\n    color: var(--brand-primary);\n    font-weight: 700;\n    padding: 6px 10px;\n    border-radius: 8px;\n    font-size: 0.8rem;\n    min-width: 50px;\n    text-align: center;\n}\n\n.match-row-info {\n    flex: 1;\n}\n\n.match-row-opponent {\n    font-weight: 600;\n    color: var(--text-main);\n    display: block;\n}\n\n.match-row-time {\n    font-size: 0.8rem;\n    color: var(--text-muted);\n}\n\n.americanas-widget {\n    border-left: 4px solid var(--brand-accent);\n}\n\n.americana-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px;\n    border-radius: 8px;\n    cursor: pointer;\n    background-color: #fff;\n    border: 1px solid var(--border-light);\n    transition: all 0.2s;\n    margin-bottom: 8px;\n}\n\n.americana-row:hover {\n    background-color: var(--bg-app);\n    border-color: var(--brand-accent);\n    transform: translateX(2px);\n}\n\n.date-box.yellow {\n    background-color: var(--brand-accent);\n    color: var(--brand-primary);\n    font-weight: 800;\n}\n\n.action-arrow {\n    margin-left: auto;\n    color: var(--brand-accent);\n    font-size: 0.9rem;\n}\n\n.btn-dashed {\n    width: 100%;\n    background: transparent;\n    border: 1px dashed var(--border-light);\n    color: var(--text-muted);\n    padding: 10px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 600;\n    font-size: 0.85rem;\n    margin-top: 10px;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.btn-dashed:hover {\n    border-color: var(--brand-primary);\n    color: var(--brand-primary);\n    background-color: #fff;\n}\n\n.stats-card {\n    background: var(--bg-card);\n    border-radius: var(--radius-lg);\n    padding: 24px;\n    box-shadow: var(--shadow-sm);\n    border: 1px solid var(--border-light);\n    height: 100%;\n}\n\n.table-responsive {\n    overflow-x: auto;\n}\n\n.custom-table {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 500px;\n}\n\n.custom-table th {\n    text-align: left;\n    padding: 12px;\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    color: var(--text-muted);\n    border-bottom: 1px solid var(--border-light);\n}\n\n.custom-table td {\n    padding: 12px;\n    border-bottom: 1px solid var(--bg-app);\n    color: var(--text-main);\n    font-size: 0.95rem;\n}\n\n.custom-table tr:hover td {\n    background-color: #F8FAFC;\n}\n\n.player-cell {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.avatar-circle {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background-color: var(--brand-accent);\n    color: var(--brand-primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    font-size: 0.8rem;\n}\n\n.points-badge {\n    font-weight: 800;\n    color: var(--brand-primary);\n    background: rgba(15, 23, 42, 0.05);\n    padding: 4px 8px;\n    border-radius: 6px;\n}\n\n.empty-hero {\n    text-align: center;\n    padding: 40px 0;\n    opacity: 0.7;\n}\n\n.loading-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 100px 20px;\n    color: var(--text-muted);\n}\n\n.spinner {\n    width: 44px;\n    height: 44px;\n    border: 4px solid var(--border-light);\n    border-top: 4px solid var(--brand-primary);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-bottom: 16px;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.info-banner-modern {\n    background-color: #F0F9FF;\n    border: 1px solid #BAE6FD;\n    color: #0369A1;\n    padding: 16px;\n    border-radius: var(--radius-md);\n    margin-bottom: 30px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: 0.95rem;\n    animation: fadeIn 0.4s ease-out;\n}\n\n.info-banner-modern i {\n    font-size: 1.2rem;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(-10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.error-banner {\n    background-color: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: var(--error);\n    padding: 12px;\n    border-radius: var(--radius-md);\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n.modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0,0,0,0.5);\n    backdrop-filter: blur(4px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000;\n}\n\n.modal-content {\n    background: white;\n    padding: 24px;\n    border-radius: var(--radius-lg);\n    width: 90%;\n    max-width: 450px;\n    box-shadow: var(--shadow-card);\n    position: relative;\n    animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(-20px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.modal-form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-top: 20px;\n}\n\n.modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: 24px;\n}\n\n.form-group label {\n    display: block;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: var(--text-main);\n    margin-bottom: 6px;\n}\n\n.form-control {\n    width: 100%;\n    height: 44px;\n    padding: 0 12px;\n    background-color: var(--bg-input);\n    border: 1px solid var(--border-light);\n    border-radius: var(--radius-input);\n    font-size: 0.95rem;\n    color: var(--text-main);\n    box-sizing: border-box;\n}\n\n.form-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n}\n\n.btn-submit {\n    background-color: var(--brand-primary);\n    color: #fff;\n    border: none;\n    padding: 10px 20px;\n    border-radius: var(--radius-input);\n    font-weight: 700;\n    cursor: pointer;\n}\n\n.btn-submit:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n}\n\n@media (max-width: 1024px) {\n    .dashboard-grid {\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n    }\n\n    .dashboard-grid > div {\n        width: 100%;\n    }\n}\n\n@media (max-width: 600px) {\n    .dashboard-header {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .dashboard-meta {\n        align-items: flex-start;\n        width: 100%;\n        flex-direction: row;\n        flex-wrap: wrap;\n    }\n\n    stats-card {\n        padding: 15px 10px;\n    }\n\n    .custom-table {\n        min-width: auto;\n    }\n\n    .custom-table th,\n    .custom-table td {\n        padding: 8px 4px;\n        font-size: 0.8rem;\n    }\n\n    .custom-table td {\n        padding: 10px 4px;\n    }\n\n    .avatar-circle.compact {\n        width: 23px;\n        height: 23px;\n        min-width: 23px;\n        font-size: 0.8rem;\n    }\n\n    .player-cell {\n        gap: 8px;\n    }\n\n    .player-name-text {\n        max-width: 100px;\n        font-size: 0.875rem;\n        font-weight: 500;\n    }\n\n    .points-badge {\n        padding: 2px 4px;\n        font-size: 0.75rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
